import React from "react";
import { Box, Typography } from "@mui/material";

const DayCell = ({
  day,
  isToday,
  onClick,
  disabled,
  status,
  attendanceData,
  regularizationData,
  shiftData,
  leaveData,
}) => {
  const statusColors = {
    A: "red",
    "Probationary Leave": "#d1d1d1", // Probationary Leave
    "Privilege Leave": "#d1d1d1", // Privilege Leave
    "Paternity Leave": "#d1d1d1", // Paternity Leave
    "Maternity Leave": "#646262", // Maternity Leave
    "Casual Leave": "#d1d1d1", // Casual Leave
    "Sick Leave": "#d1d1d1", // Sick Leave
    "Marriage Leave": "#646262", // Marriage Leave
    "Bereavement Leave": "#646262", // Bereavement Leave
    "Comp Off": "#bebebe", // Comp Off
    "On Duty": "#FFAD76", // On Duty
    "Work From Home": "#8DE6C7", // Work From Home
    H: "#556B83",
    "Restricted Holiday": "#F8BA52",
    "Regularize Approved": "#b3f89d",
    "Regularize Pending": "#f3de46",
    "Regularize Rejected": "#F9B4B4",
    "Leave Pending": "#e2bae8",
  };

  return (
    <Box
      onClick={() => !disabled && onClick?.(day)}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: 100,
        borderRadius: 1,
        color: disabled ? "#ECECEC" : "text.primary",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        position: "relative",
      }}
    >
      {/* Date Number */}
      <Typography
        fontSize={16}
        fontWeight={600}
        lineHeight={"19px"}
        sx={{
          color: disabled
            ? (theme) => theme.palette.BudgieThemeColor.Neutrals[700]
            : (theme) => theme.palette.BudgieThemeColor.Neutrals[1300],
        }}
      >
        {day.getDate()}
      </Typography>

      {/* Status Text Only */}
      {!disabled && attendanceData && (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              mt: 1,
              px: 1,
              width: 62,
              height: 60,
              borderRadius: "50%", // Makes it a circle
              backgroundColor:
                regularizationData === "Approved"
                  ? statusColors["Regularize Approved"]
                  : regularizationData === "Pending"
                  ? statusColors["Regularize Pending"]
                  : regularizationData === "Rejected"
                  ? statusColors["Regularize Rejected"]
                  : attendanceData === "SL"
                  ? statusColors["Sick Leave"]
                  : attendanceData === "CL"
                  ? statusColors["Casual Leave"]
                  : attendanceData === "PRL"
                  ? statusColors["Probationary Leave"]
                  : attendanceData === "PL"
                  ? statusColors["Privilege Leave"]
                  : attendanceData === "PNL"
                  ? statusColors["Paternity Leave"]
                  : attendanceData === "MNL"
                  ? statusColors["Maternity Leave"]
                  : attendanceData === "MAL"
                  ? statusColors["Marriage Leave"]
                  : attendanceData === "BL"
                  ? statusColors["Bereavement Leave"]
                  : attendanceData === "OD"
                  ? statusColors["On Duty"]
                  : attendanceData === "On Duty"
                  ? statusColors["On Duty"]
                  : attendanceData === "WFH"
                  ? statusColors["Work From Home"]
                  : attendanceData === "CO"
                  ? statusColors["Comp Off"]
                  : attendanceData === "Compensatory Leave"
                  ? statusColors["Comp Off"]
                  : leaveData === "Pending"
                  ? statusColors["Leave Pending"]
                  : "transparent",
            }}
          >
            <Typography
              variant="caption"
              sx={{
                fontWeight: 500,
                fontSize: 14,
                lineHeight: 1.2,
                textAlign: "center",
                wordBreak: "break-word",
                maxWidth: "100%",
                // display: "flex",
              }}
            >
              {/* {attendanceData?.split(":").map((part, index) => (
                <React.Fragment key={index}>
                  <span
                    style={{
                      color: part.trim() === "A" ? "red" : "inherit",
                      letterSpacing: "1px", // Add space inside the part
                    }}
                  >
                    {part}
                  </span>
                  
                  {index !== attendanceData.split(":").length - 1 && (
                    <span style={{ margin: "0 1px", color: "inherit" }}> : </span> // Space around ":" symbol
                  )}
                </React.Fragment>
              ))} */}

              {attendanceData?.split(":").map((part, index) => {
                const trimmedPart = part.trim();
                const displayPart =
                  trimmedPart === "On Duty"
                    ? "OD"
                    : trimmedPart === "Compensatory Leave"
                    ? "CO"
                    : trimmedPart;

                return (
                  <React.Fragment key={index}>
                    <span
                      style={{
                        color: displayPart === "A" ? "red" : "inherit",
                        letterSpacing: "1px",
                      }}
                    >
                      {displayPart}
                    </span>
                    {/* Show ":" only between parts, not after last part */}
                    {index !== attendanceData.split(":").length - 1 && (
                      <span style={{ margin: "0 1px", color: "inherit" }}>
                        {" "}
                        :{" "}
                      </span>
                    )}
                  </React.Fragment>
                );
              })}
            </Typography>

            {/* Shift Data */}
            {shiftData &&
              attendanceData !== "OFF" &&
              attendanceData !== "H" &&
              attendanceData !== "CO" &&
              attendanceData !== "CL" &&
              attendanceData !== "SL" &&
              attendanceData !== "PL" &&
              attendanceData !== "RH" &&
              attendanceData !== "MNL" &&
              attendanceData !== "PNL" &&
              attendanceData !== "PRL" &&
              attendanceData !== "WFH" &&
              attendanceData !== "OD" &&
              attendanceData !== "Compensatory Leave" &&
              attendanceData !== "On Duty" && (
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 500,
                    fontSize: 12,
                    lineHeight: 1,
                    mt: 0.5, // Adds some spacing
                    color: "#9c9897",
                  }}
                >
                  {shiftData}
                </Typography>
              )}

            {/* Big Dot for Holiday */}
            {attendanceData === "H" && !disabled && (
              <Box
                sx={{
                  position: "absolute",
                  top: 6,
                  right: 6,
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: "#556B83", // Blue color dot
                }}
              />
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

export default DayCell;
